import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import { useTranslation } from "react-i18next";

const Neighborhood = () => {
  const { t } = useTranslation();

  return (
    <ImageLoader>
      <Container>
        <Row className="section">
          <AnimateOnScroll animationType="slideUp">
            <h2>{t("neighborhood_main_title")}</h2>
          </AnimateOnScroll>
        </Row>
        <Row className="section ">
          <Col md={12}></Col>
          <Row>
            <Col md={6}>
              <AnimateOnScroll animationType="slideLeft">
                <img
                  src="/images/mmexport1747815841641.jpg"
                  alt="One Oasis"
                  className="fullimg aspect-16-9"
                />
              </AnimateOnScroll>
            </Col>
            <Col md={6}>
              <AnimateOnScroll animationType="slideRight">
                <img
                  src="/images/mmexport1747816180115.jpg"
                  alt="One Oasis"
                  className="fullimg aspect-16-9"
                />
              </AnimateOnScroll>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <AnimateOnScroll animationType="slideUp">
                <h2>{t("neighborhood_green_title")}</h2>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("neighborhood_green_p"),
                  }}
                ></p>
              </AnimateOnScroll>
            </Col>
          </Row>
        </Row>
        <Row className="section d">
          <Col md={6}>
            <AnimateOnScroll animationType="slideUp">
              <img
                src="/images/M2.jpg"
                alt="One Oasis"
                className="fullimg aspect-16-9"
              />
            </AnimateOnScroll>
          </Col>
          <Col md={6} className="d-flex flex-column justify-content-center">
            <AnimateOnScroll animationType="slideUp">
              <h2>{t("neighborhood_vibrancy_title")}</h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: t("neighborhood_vibrancy_p"),
                }}
              ></p>
            </AnimateOnScroll>
          </Col>
        </Row>
        <Row className="section">
          <Col md={6}>
            <AnimateOnScroll animationType="slideLeft">
              <img
                src="/images/new_28.jpg"
                alt="One Oasis"
                className="fullimg aspect-16-9"
              />
            </AnimateOnScroll>
          </Col>
          <Col md={6}>
            <AnimateOnScroll animationType="slideRight">
              <img
                src="/images/bridge.jpg"
                alt="One Oasis"
                className="fullimg aspect-16-9"
              />
            </AnimateOnScroll>
          </Col>
        </Row>
        <Row className="section ">
          <Col md={4} className="d-flex flex-column justify-content-center">
            <AnimateOnScroll animationType="slideUp">
              <h2>{t("neighborhood_retreat_title")}</h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: t("neighborhood_retreat_p"),
                }}
              ></p>
            </AnimateOnScroll>
          </Col>
          <Col md={8}>
            <AnimateOnScroll animationType="slideUp">
              <img
                src="/images/panda.jpg"
                alt="One Oasis"
                className="fullimg aspect-16-9"
              />
            </AnimateOnScroll>
          </Col>
        </Row>
        <Row className="section">
          <Row>
            <AnimateOnScroll animationType="slideUp">
              <h2>{t("neighborhood_network_title")}</h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: t("neighborhood_network_p"),
                }}
              ></p>
            </AnimateOnScroll>
          </Row>
          <Row>
            <Col md={4}>
              <AnimateOnScroll animationType="slideUp" delay={0.1}>
                <img
                  src="/images/new_14.jpg"
                  alt="One Oasis"
                  className="fullimg aspect-16-9"
                />
              </AnimateOnScroll>
            </Col>
            <Col md={4}>
              <AnimateOnScroll animationType="slideUp" delay={0.2}>
                <img
                  src="/images/bridge_02.jpg"
                  alt="One Oasis"
                  className="fullimg aspect-16-9"
                />
              </AnimateOnScroll>
            </Col>
            <Col md={4}>
              <AnimateOnScroll animationType="slideUp" delay={0.3}>
                <img
                  src="/images/macau_transit.jpg"
                  alt="One Oasis"
                  className="fullimg aspect-16-9"
                />
              </AnimateOnScroll>
            </Col>
          </Row>
        </Row>
      </Container>
    </ImageLoader>
  );
};

export default Neighborhood;
